import { withStyles } from '@material-ui/core/styles';
import pluralize from 'pluralize';
import React from 'react';
import { Admin, Layout, Login, Resource } from 'react-admin';
import authProvider from './authProvider';
import dataProvider from './dataProvider';
import { ErrorPage, Menu, Theme } from './layout';
import base64UploadDecorator from './lib/base64UploadDecorator';
import reducers from './reducers';
import customRoutes from './routes';
import sagas from './sagas';
import { history } from './sentry';

pluralize.addSingularRule(/skus$/i, 'sku');

const styles = {
  root: {
    width: '100%',
    maxWidth: 500,
  },
};

const AppLayout = props => (
  <Layout
    {...props}
    error={ErrorPage}
    menu={Menu}
  />
);

const LoginPage = ({ classes, ...props }) => (
  <Login
    {...props}
    backgroundImage="/background.jpg"
  />
);

const App = () => (
  <Admin
    appLayout={AppLayout}
    authProvider={authProvider}
    customReducers={reducers}
    customRoutes={customRoutes}
    customSagas={sagas}
    dataProvider={base64UploadDecorator(dataProvider)}
    history={history}
    loginPage={LoginPage}
    theme={Theme}
    title="Houston"
  >
    <Resource
      name="avatars"
    />
    <Resource
      name="badge_achievements"
    />
    <Resource
      name="badge_dependent_badges"
    />
    <Resource
      name="badge_skills"
    />
    <Resource
      name="badges"
    />
    <Resource
      name="badge_conditions"
    />
    <Resource
      name="badge_comparables"
    />
    <Resource
      name="bank_balance_adjustments"
    />
    <Resource
      name="bank_balances"
    />
    <Resource
      name="courses"
    />
    <Resource
      name="curriculum_activities"
    />
    <Resource
      name="curriculum_accomplishments"
    />
    <Resource
      name="curriculum_activity_skills"
    />
    <Resource
      name="curriculum_scores"
    />
    <Resource
      name="difficulties"
    />
    <Resource
      name="documents"
    />
    <Resource
      name="economy_ledgers"
    />
    <Resource
      name="friend_requests"
    />
    <Resource
      name="followings"
    />
    <Resource
      name="guide_ranks"
    />
    <Resource
      name="guide_rank_learning_path_levels"
    />
    <Resource
      name="log_entries"
    />
    <Resource
      name="keyring_purchases"
    />
    <Resource
      name="keyring_grants"
    />
    <Resource
      name="launched_apps"
    />
    <Resource
      name="learning_path_levels"
    />
    <Resource
      name="learning_path_level_skill_levels"
    />
    <Resource
      name="learning_paths"
    />
    <Resource
      name="library_categories"
    />
    <Resource
      name="library_engine_configuration_options"
    />
    <Resource
      name="library_engine_configuration_templates"
    />
    <Resource
      name="library_engine_event_modules"
    />
    <Resource
      name="library_engine_event_parameters"
    />
    <Resource
      name="library_engine_events"
    />
    <Resource
      name="library_engine_method_modules"
    />
    <Resource
      name="library_engine_method_parameters"
    />
    <Resource
      name="library_engine_methods"
    />
    <Resource
      name="library_engine_modules"
    />
    <Resource
      name="library_engines"
    />
    <Resource
      name="library_engine_versions"
    />
    <Resource
      name="library_object_configuration_templates"
    />
    <Resource
      name="library_object_configuration_values"
    />
    <Resource
      name="library_object_constant_values"
    />
    <Resource
      name="library_object_constants"
    />
    <Resource
      name="library_object_event_modules"
    />
    <Resource
      name="library_object_event_parameters"
    />
    <Resource
      name="library_object_events"
    />
    <Resource
      name="library_object_included_engine_events"
    />
    <Resource
      name="library_object_included_engine_methods"
    />
    <Resource
      name="library_object_method_modules"
    />
    <Resource
      name="library_object_method_parameters"
    />
    <Resource
      name="library_object_methods"
    />
    <Resource
      name="library_object_reactions"
    />
    <Resource
      name="library_object_reaction_modules"
    />
    <Resource
      name="library_objects"
    />
    <Resource
      name="library_object_versions"
    />
    <Resource
      name="library_keyrings"
    />
    <Resource
      name="library_widgets"
    />
    <Resource
      name="memberships"
    />
    <Resource
      name="mission_achievements"
    />
    <Resource
      name="mission_skills"
    />
    <Resource
      name="missions"
    />
    <Resource
      name="organizations"
    />
    <Resource
      name="projects"
    />
    <Resource
      name="project_categories"
    />
    <Resource
      name="revisions"
    />
    <Resource
      name="ranks"
    />
    <Resource
      name="rank_learning_path_levels"
    />
    <Resource
      name="steps"
    />
    <Resource
      name="subscriptions"
    />
    <Resource
      name="skills"
    />
    <Resource
      name="skill_levels"
    />
    <Resource
      name="tutorials"
    />
    <Resource
      name="users"
    />
    <Resource
      name="versions"
    />
    <Resource
      name="version_comments"
    />
    <Resource
      name="version_flags"
    />
    <Resource
      name="version_stars"
    />
    <Resource
      name="version_status_changes"
    />
  </Admin>
);

export default withStyles(styles)(App);
